import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/aliados/buk")({
  beforeLoad: () => {
    throw redirect({ to: "/cursos/empresas/buk" });
  },
});
